import { api } from "./client";

export interface Me {
  user_id: string;
  email: string | null;
  name: string | null;
  permissions: string[];
  // kraken is org-aware: the active org comes from the token. The list of
  // orgs the user belongs to is fetched separately (see api/orgs.ts).
  current_org_id: string | null;
}

export const meApi = {
  getMe: () => api.get<Me>("/api/dashboard/me"),
};
